const SendFeedbackContainer = {
    sendFeedback: (): void => {
        //To be overriden in owa-mail with appropriate logic
    },
};

export default SendFeedbackContainer;
